import {GET_STUDENT_SESSIONS,GET_TEACHER_DETAILS, SET_DASHBOARD_FILTERS, GET_STUDENT_PRACTICE_SESSIONS, GET_STUDENT_CHALLENGE_SESSIONS, GET_CLASS_ASSIGNMENT_SESSION,GET_STUDENT_CHAPTER_PROGRESS, GET_LEADERBOARD, GET_CLASS_PROGRESS} from "../../constants/ActionTypes";

export const getStudentSessions = () => {
  return {
    type: GET_STUDENT_SESSIONS
  }
};

export const getTeacherDetails = () => {
  return {
    type: GET_TEACHER_DETAILS
  }
};

export const updateDashboardFilter = (payload)=>{
  return {
    type:SET_DASHBOARD_FILTERS,
    payload
  }
}
export const getStudentPracticeSessions = (payload)=>{
  return {
    type:GET_STUDENT_PRACTICE_SESSIONS,
    payload
  }
}
export const getStudentChapterProgress = (payload)=>{
  return {
    type:GET_STUDENT_CHAPTER_PROGRESS,
    payload
  }
}
export const getStudentChallengeSessions = (payload)=>{
  return {
    type:GET_STUDENT_CHALLENGE_SESSIONS,
    payload
  }
}
export const getClassAssignmentSession = (payload)=>{
  return {
    type:GET_CLASS_ASSIGNMENT_SESSION,
    payload
  }
}
export const getClassLeaderboard = (payload)=>{
  return {
    type:GET_LEADERBOARD,
    payload
  }
}
export const getClassProgress = (payload)=>{
  return {
    type:GET_CLASS_PROGRESS,
    payload
  }
}

